// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.configmain
{
  width:100%;
  height:100vh;
  background-color: #000000;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap:25px
}
.confignav
{
  margin-left: 360px;
  height:8%;
  /* background-image: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%); */
  align-items: center;
  justify-content: center;
  display: flex;
  color: white;
}
.head_div{
  display: flex;
  align-items: center;
  width: 100%;
}
.detail_input{
 border: 2px solid black;
  padding: 4px 4px;
}
.configcard
{
  height:616px;
  margin-bottom: 20px;
  padding: 20px;
  width:600px;
  background-color: white;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  gap:15px;
  border-radius: 15px;
}
.liclog
{
  height:20px;
  width:20px
}
.inlo
{
  display: flex;
 justify-content: space-between;
 width: 500px;
 color: black;
}
.inlo > label{
  color: black;
}
.button-68 {
  appearance: none;
  backface-visibility: hidden;
  background-color: #27ae60;
  border-radius: 8px;
  border-style: none;
  box-shadow: rgba(39, 174, 96, .15) 0 4px 9px;
  box-sizing: border-box;
  color: #fff;
  cursor: pointer;
  display: inline-block;
  font-family: Inter,-apple-system,system-ui,"Segoe UI",Helvetica,Arial,sans-serif;
  font-size: 1em;
  font-weight: 400;
  letter-spacing: normal;
  line-height: 1;
  outline: none;
  overflow: hidden;
  padding: 10px 15px;
  position: relative;
  text-align: center;
  text-decoration: none;
  transform: translate3d(0, 0, 0);
  transition: all .3s;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  vertical-align: top;
  white-space: nowrap;
  align-items: center;
  justify-content: center;
}

.button-68:hover {
  background-color: #1e8449;
  opacity: 1;
  transform: translateY(0);
  transition-duration: .35s;
}

.button-68:active {
  transform: translateY(2px);
  transition-duration: .35s;
}

.button-68:hover {
  box-shadow: rgba(39, 174, 96, .2) 0 6px 12px;
}


.button-44 {
  background: #e62143;
  border-radius: 11px;
  box-sizing: border-box;
  color: #fff;
  cursor: pointer;
  display: flex;
  font-family: Mija,-apple-system,BlinkMacSystemFont,Roboto,"Roboto Slab","Droid Serif","Segoe UI",system-ui,Arial,sans-serif;
  font-size: 1em;
  font-weight: 400;
  justify-content: center;
  line-height: 1;
  padding: 0.6em 0.4em;
  text-align: center;
  text-decoration: none;
  text-decoration-skip-ink: auto;
  text-shadow: rgba(0, 0, 0, .3) 1px 1px 1px;
  text-underline-offset: 1px;
  transition: all .2s ease-in-out;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  width: 20%;
  word-break: break-word;
  border: 0;
}

.button-44:active,
.button-44:focus {
  border-bottom-style: none;
  border-color: #dadada;
  box-shadow: rgba(0, 0, 0, .3) 0 3px 3px inset;
  outline: 0;
}

.button-44:hover {
  border-bottom-style: none;
  border-color: #dadada;
}

.configdn
{
  width:100%;
  display: flex;
  align-items: center;
  justify-content: space-around;

}

.configcard label
{
  font-size: 18px;
}

.confimg
{
  height:15px;
  width:15px
}`, "",{"version":3,"sources":["webpack://./src/components/Configure.css"],"names":[],"mappings":"AAAA;;EAEE,UAAU;EACV,YAAY;EACZ,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB;AACF;AACA;;EAEE,kBAAkB;EAClB,SAAS;EACT,yEAAyE;EACzE,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,YAAY;AACd;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;AACA;CACC,uBAAuB;EACtB,gBAAgB;AAClB;AACA;;EAEE,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,WAAW;EACX,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;EACR,mBAAmB;AACrB;AACA;;EAEE,WAAW;EACX;AACF;AACA;;EAEE,aAAa;CACd,8BAA8B;CAC9B,YAAY;CACZ,YAAY;AACb;AACA;EACE,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,4CAA4C;EAC5C,sBAAsB;EACtB,WAAW;EACX,eAAe;EACf,qBAAqB;EACrB,gFAAgF;EAChF,cAAc;EACd,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EACrB,+BAA+B;EAC/B,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;EACzB,0BAA0B;EAC1B,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,UAAU;EACV,wBAAwB;EACxB,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,4CAA4C;AAC9C;;;AAGA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,sBAAsB;EACtB,WAAW;EACX,eAAe;EACf,aAAa;EACb,2HAA2H;EAC3H,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,oBAAoB;EACpB,kBAAkB;EAClB,qBAAqB;EACrB,8BAA8B;EAC9B,0CAA0C;EAC1C,0BAA0B;EAC1B,+BAA+B;EAC/B,iBAAiB;EACjB,yBAAyB;EACzB,0BAA0B;EAC1B,UAAU;EACV,sBAAsB;EACtB,SAAS;AACX;;AAEA;;EAEE,yBAAyB;EACzB,qBAAqB;EACrB,6CAA6C;EAC7C,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,6BAA6B;;AAE/B;;AAEA;;EAEE,eAAe;AACjB;;AAEA;;EAEE,WAAW;EACX;AACF","sourcesContent":[".configmain\r\n{\r\n  width:100%;\r\n  height:100vh;\r\n  background-color: #000000;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  gap:25px\r\n}\r\n.confignav\r\n{\r\n  margin-left: 360px;\r\n  height:8%;\r\n  /* background-image: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%); */\r\n  align-items: center;\r\n  justify-content: center;\r\n  display: flex;\r\n  color: white;\r\n}\r\n.head_div{\r\n  display: flex;\r\n  align-items: center;\r\n  width: 100%;\r\n}\r\n.detail_input{\r\n border: 2px solid black;\r\n  padding: 4px 4px;\r\n}\r\n.configcard\r\n{\r\n  height:616px;\r\n  margin-bottom: 20px;\r\n  padding: 20px;\r\n  width:600px;\r\n  background-color: white;\r\n  display: flex;\r\n  align-items: center;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  gap:15px;\r\n  border-radius: 15px;\r\n}\r\n.liclog\r\n{\r\n  height:20px;\r\n  width:20px\r\n}\r\n.inlo\r\n{\r\n  display: flex;\r\n justify-content: space-between;\r\n width: 500px;\r\n color: black;\r\n}\r\n.inlo > label{\r\n  color: black;\r\n}\r\n.button-68 {\r\n  appearance: none;\r\n  backface-visibility: hidden;\r\n  background-color: #27ae60;\r\n  border-radius: 8px;\r\n  border-style: none;\r\n  box-shadow: rgba(39, 174, 96, .15) 0 4px 9px;\r\n  box-sizing: border-box;\r\n  color: #fff;\r\n  cursor: pointer;\r\n  display: inline-block;\r\n  font-family: Inter,-apple-system,system-ui,\"Segoe UI\",Helvetica,Arial,sans-serif;\r\n  font-size: 1em;\r\n  font-weight: 400;\r\n  letter-spacing: normal;\r\n  line-height: 1;\r\n  outline: none;\r\n  overflow: hidden;\r\n  padding: 10px 15px;\r\n  position: relative;\r\n  text-align: center;\r\n  text-decoration: none;\r\n  transform: translate3d(0, 0, 0);\r\n  transition: all .3s;\r\n  user-select: none;\r\n  -webkit-user-select: none;\r\n  touch-action: manipulation;\r\n  vertical-align: top;\r\n  white-space: nowrap;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.button-68:hover {\r\n  background-color: #1e8449;\r\n  opacity: 1;\r\n  transform: translateY(0);\r\n  transition-duration: .35s;\r\n}\r\n\r\n.button-68:active {\r\n  transform: translateY(2px);\r\n  transition-duration: .35s;\r\n}\r\n\r\n.button-68:hover {\r\n  box-shadow: rgba(39, 174, 96, .2) 0 6px 12px;\r\n}\r\n\r\n\r\n.button-44 {\r\n  background: #e62143;\r\n  border-radius: 11px;\r\n  box-sizing: border-box;\r\n  color: #fff;\r\n  cursor: pointer;\r\n  display: flex;\r\n  font-family: Mija,-apple-system,BlinkMacSystemFont,Roboto,\"Roboto Slab\",\"Droid Serif\",\"Segoe UI\",system-ui,Arial,sans-serif;\r\n  font-size: 1em;\r\n  font-weight: 400;\r\n  justify-content: center;\r\n  line-height: 1;\r\n  padding: 0.6em 0.4em;\r\n  text-align: center;\r\n  text-decoration: none;\r\n  text-decoration-skip-ink: auto;\r\n  text-shadow: rgba(0, 0, 0, .3) 1px 1px 1px;\r\n  text-underline-offset: 1px;\r\n  transition: all .2s ease-in-out;\r\n  user-select: none;\r\n  -webkit-user-select: none;\r\n  touch-action: manipulation;\r\n  width: 20%;\r\n  word-break: break-word;\r\n  border: 0;\r\n}\r\n\r\n.button-44:active,\r\n.button-44:focus {\r\n  border-bottom-style: none;\r\n  border-color: #dadada;\r\n  box-shadow: rgba(0, 0, 0, .3) 0 3px 3px inset;\r\n  outline: 0;\r\n}\r\n\r\n.button-44:hover {\r\n  border-bottom-style: none;\r\n  border-color: #dadada;\r\n}\r\n\r\n.configdn\r\n{\r\n  width:100%;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-around;\r\n\r\n}\r\n\r\n.configcard label\r\n{\r\n  font-size: 18px;\r\n}\r\n\r\n.confimg\r\n{\r\n  height:15px;\r\n  width:15px\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
